<template>
  <Popup
    name="tour"
    :extra-classes="popupClasses"
    :position="popupPosition"
    context="global"
  >
    <template v-slot:content>
      <div class="tour__page">{{ step + 1 }} / {{ totalSteps }}</div>
      <h3
        class="tour__title"
        :class="`tour__title--${step + 1}`"
        v-if="step === 0"
      >
        Willkommen bei den eFriends!
      </h3>
      <div class="tour__content">
        <p v-if="step === 0">
          Willkommen bei eFriends! Wir zeigen dir jetzt die eFriends MAP.<br />Hier
          verbinden sich eFriends und teilen ihren Strom.
        </p>
        <p v-if="step === 1">
          eFriend Klara hat eine PV-Anlage – und überschüssigen Strom.<br />
          Du und eFriend Klara sind schon verbunden:<br />
          Jetzt beziehst du von Klara überschüssigen Sonnenstrom – immer dann
          wenn sie zuviel davon hat!
        </p>
        <p v-if="step === 2">
          Ein guter Anfang! Weiter geht's mit eFriend Julia:<br />
          Ihr Wasserkraftwerk leistet bis zu 65 Kilowatt (kW).<br />Klicke auf
          ihr blaues Symbol, um dich mit ihr zu verbinden.
        </p>
        <p v-if="step === 3">
          Wow! Dank Klara und Julia beziehst du nun schon bis zu
          {{ communitySharePercent }}% deines Strombedarfs von anderen eFriends.
        </p>
        <p v-if="step === 4">
          Den Rest beziehst du (wie bisher) von deinem Stromanbieter!
        </p>
      </div>

      <div class="tour__actions">
        <router-link
          v-if="!atEnd"
          class="button button--link button--no-padding"
          :to="destinationAfterTour"
        >
          Tour überspringen
        </router-link>
        <button
          class="button button--secondary"
          data-cy="tour-prev"
          v-if="!atBeginning"
          @click="setStep(step - 1)"
        >
          Zurück
        </button>
        <button
          class="button button--primary"
          data-cy="tour-next"
          v-if="!atEnd"
          @click="setStep(step + 1)"
        >
          Weiter
        </button>
        <router-link
          class="button button--primary"
          v-if="atEnd"
          data-cy="tour-finish"
          :to="destinationAfterTour"
          @click.native="showAfterTourPopup"
        >
          Fertig
        </router-link>
      </div>
    </template>
  </Popup>
</template>

<script>
  import { computed, defineComponent } from 'vue'
  import Popup from '@/components/popups/Popup.vue'
  import { useRouter } from 'vue-router'
  import { useSpecificPopup } from '@/composables/useSpecificPopup.ts'
  import { usePortfolioStore } from '@/stores/usePortfolioStore'

  export default defineComponent({
    components: {
      Popup,
    },
    props: {
      step: {
        type: Number,
        required: true,
      },
    },
    setup(props, { emit }) {
      const portfolioStore = usePortfolioStore()
      const router = useRouter()
      const totalSteps = 5
      const destinationAfterTour = { name: 'map' }
      const afterTourPopup = useSpecificPopup('afterTour')

      const atEnd = computed(() => props.step >= totalSteps - 1)
      const atBeginning = computed(() => props.step <= 0)

      const communitySharePercent = computed(() =>
        portfolioStore.communitySharePercent.toFixed(0)
      )

      const popupPosition = computed(() => {
        switch (props.step) {
          case 0:
            return 'center center'
          default:
            return 'right bottom'
        }
      })

      const popupClasses = computed(() => {
        const classes = ['popup--full-width-on-mobile']
        if (props.step === 0) { classes.push('popup--large') }
        else { classes.push('popup--medium') }
        return classes
      })

      function setStep(newStep) {
        emit('setStep', newStep)
      }

      function endTour() {
        this.router.push(destinationAfterTour)
      }

      function showAfterTourPopup() {
        afterTourPopup.show()
      }

      return {
        endTour,
        totalSteps,
        setStep,
        atEnd,
        atBeginning,
        destinationAfterTour,
        communitySharePercent,
        popupPosition,
        popupClasses,
        showAfterTourPopup,
        router,
      }
    },
  })
</script>

<style lang="scss">
  svg {
    overflow: initial;
  }

  .tour__actions {
    display: flex;
    justify-content: space-between;

    & > *:only-child {
      margin-left: auto;
    }
  }

  .tour__title {
    display: flex;
    justify-content: space-between;
    line-height: 1.2;

    &--1 {
      font-size: 1.8rem;
    }
  }

  .tour__page {
    float: right;
    line-height: 1;
    padding-left: $spacer10;
    padding-bottom: $spacer20;
  }

  .button--no-padding {
    font-size: 0.8rem;

    @media (min-width: $bp-lg) {
      font-size: 1rem;
    }
  }

  .button--no-padding {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 0;
  }
</style>
